import Component from "./profile.component";
import { Config } from "./profile.config";
import { watchProfile as saga } from "./redux/profile.sagas";
import { reducer } from "./redux/profile.reducer";

export default { Component, saga, reducer, config: Config };
